import { render, staticRenderFns } from "./ConfigDropdown.vue?vue&type=template&id=451a24aa"
import script from "./ConfigDropdown.vue?vue&type=script&lang=js"
export * from "./ConfigDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports